export const getSizeHead = (totalsize) => {
    let size = Math.floor(totalsize / 1024 / 1024);

    return !size ? `${Math.floor(totalsize / 1024)} Kb` : `${size} Mb`
}